import React, { Component } from "react";
import {
    Form,
    Button,
    Container,
    Row,
    Col,
    Alert,
    InputGroup,
    FormControl,
    ListGroup,
    ListGroupItem
} from "react-bootstrap";
import {Jumbotron} from "../helpers/Jumbotron";
import Axios from 'axios';
import {withRouter} from "../helpers/withRouter";
import template from "../Proposal.xlsx"
import Footer from "../Footer";
import FoursquareCategories from "../foursquare_categories.json";

class CreateCampaignPage extends Component{
    state = {
        POIs : [],
        complianceOn: false,
    };
    onSubmit = (event) => {
        const { location } = this.props;
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        data.append("campaignName",form["campaignName"].value);
        data.append("startDate",form["startDate"].value);
        data.append("endDate",form["endDate"].value);
        data.append("complianceOn",this.state.complianceOn);
        data.append("complianceRadius",form["complianceRadius"] ? form["complianceRadius"].value : undefined);
        data.append("boardsXlsx",form["boardsXlsx"].files[0]);
        data.append("POIs",this.state.POIs);
        data.append("folderId",location.state?.folderId);
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/create", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            form.reset();
            let cId = response.data["campaign_id"];
            this.props.history.push('/campaign/'+cId);
            // this.setState({campaignCreatedSuccess:form["campaignName"].value});
        }).catch(error => {
            this.setState({error :{
                    title:"Error Creating Campaign!",
                    body: "Server reported an error: "+error.responseText,
                }});
        });
    };

    addPoi = (poiCategory) =>  {
        let pois = this.state.POIs;
        if(pois.length > 4){
            this.setState({error: {
                title: "Unable to Add Poi",
                body: "Campaigns are limited to 5 POIs",
            }});
        }else{
            if(!poiCategory){
                pois.push(this.state.poiInput);
            }else{
                pois.push(poiCategory);
            }
            this.setState({POIs: pois, poiInput: ""});
        }
    }
    removePOI = (i) =>  {
        let pois = this.state.POIs;
        pois.splice(i, 1);
        this.setState({POIs: pois});
    }

    matchesPOICategorySearch(category, search){
        search = search.toLowerCase();
        let label = category.labels.en.toLowerCase();
        if(label.includes(search)){
            return true
        }
        for(let fl of category.full_label) {
            fl = fl.toLowerCase();
            if (fl.includes(search)) {
                return true
            }
        }
        return false
    }

    render() {
        return <div className={"main-container"}>
            <Container>
                <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5"}>
                    <Form onSubmit={this.onSubmit}>
                        <Row className={"mb-4"}>
                            <Col>
                                <h2>New Campaign</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="campaignName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control type="text" placeholder="Enter name of campaign" required/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="startDate">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control type="date" required/>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="endDate">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control type="date" placeholder="01/01/2001" required/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label>POIs</label>
                                <InputGroup className="mb-3">
                                    {/*<InputGroup.Label>*/}
                                    {/*    POIs*/}
                                    {/*</InputGroup.Label>*/}
                                    <FormControl
                                        placeholder="Enter query fields"
                                        aria-label="Enter query fields"
                                        aria-describedby="basic-addon2"
                                        value={this.state.poiInput}
                                        onChange={e => this.setState({ poiInput: e.target.value })}
                                    />
                                    <Button onClick={()=>{this.addPoi()}} variant="primary">Add Custom Search</Button>
                                </InputGroup>
                                {this.state.poiInput && this.state.poiInput.length ?<ListGroup className={"mb-4"} style={{maxHeight:200,overflow:"scroll",fontSize:"0.8rem"}}>
                                    {Object.keys(FoursquareCategories).map((key,i) => {
                                        let category = FoursquareCategories[key];
                                        if(!this.matchesPOICategorySearch(category,this.state.poiInput)){
                                            return <></>
                                        }
                                        return <ListGroup.Item key={i} action onClick={(ev)=>{ev.preventDefault();this.addPoi(category.labels.en)}}>
                                            {category.full_label.length > 1 ? category.labels.en : <b>{category.labels.en}</b>}
                                        </ListGroup.Item>
                                    })}
                                </ListGroup> :""}
                                <p className={"mb-4"}><i>The autofilled POI's have better results.</i></p>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={"added-poi-container"}>
                                {this.state.POIs.map((poi,i) => {
                                    return <div className={"green-btn ft-md added-poi"} key={i}>{poi}<div onClick={()=>this.removePOI(i)} className={"close-icon"}/></div>
                                })}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p className={"d-inline-block"}>Compliance</p>
                                <Form.Check
                                    className={"d-inline-block ms-3"}
                                    type="switch"
                                    id="custom-switch"
                                    checked={this.state.complianceOn}
                                    onChange={()=>this.setState({complianceOn: !this.state.complianceOn})}
                                />
                            </Col>
                            <Col>

                            </Col>
                        </Row>
                        {this.state.complianceOn ?
                            <Row>
                                <Col>
                                    <Form.Group controlId="complianceRadius">
                                        <Form.Label>Compliance Radius (ft)</Form.Label>
                                        <Form.Control type="number" max={10560} min={50} placeholder={"5280 (1 Mi)"}  required/>
                                    </Form.Group>
                                </Col>
                            </Row>
                            :<></>
                        }
                        <Row>
                            <Col>
                                <Form.Group controlId="boardsXlsx">
                                    <Form.Label>Media XLSX</Form.Label>
                                    <Form.Control type="file" accept=".xlsx"/>
                                    <Form.Text className="text-muted">
                                        Template: <a href={template}>File</a>
                                        <br/>
                                        {/*<i>Add <b>Bus</b> and <b>Train</b> media after the campaign is created.</i>*/}
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className={"mt-4"}>
                            <Col>
                                <Button variant="primary" type="submit">
                                    Create Campaign
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Jumbotron>
                <div className={"mx-auto mt-5"}>
                </div>
                {this.state.error ? (
                    <Alert style={{maxWidth:500}} className={"mx-auto alert-top-right"}  variant="danger" onClose={()=>{this.setState({error: null})}} dismissible>
                        <Alert.Heading>{this.state.error.title}</Alert.Heading>
                        <p>{this.state.error.body}</p>
                    </Alert>
                ):(
                    <></>
                )}
                <Footer/>
            </Container>
        </div>
    }
}

export default withRouter(CreateCampaignPage);
